/* eslint-disable */
export default {
  title: '音訊',
  input: '輸入',
  microphone: '麥克風',
  autoAdjustMicLevel: '自動調整麥克風音量',
  output: '輸出',
  speakerSource: '喇叭來源',
  speakerVolume: '喇叭音量',
  ringtoneSource: '鈴聲和通知聲源',
  ringtoneVolume: '鈴聲和通知音量',
  ringtones: '鈴聲',
  noDevices: '無裝置',
  off: '關閉',
  noLabel: '未知的裝置',
  stopRecordDescription: '請說話以測試麥克風音量（{countDown} 秒）',
  stopPlaybackDescription: '正在播放錄音…',
  startRecordButton: '測試麥克風',
  stopRecordButton: '停止錄製',
  stopPlaybackButton: '停止測試',
  startTestButton: '測試喇叭',
  stopTestDescription: '正在播放範例音效...',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"input"@#@ @source: @#@"Input"@#@
// @key: @#@"microphone"@#@ @source: @#@"Microphone"@#@
// @key: @#@"autoAdjustMicLevel"@#@ @source: @#@"Automatically adjust my mic level"@#@
// @key: @#@"output"@#@ @source: @#@"Output"@#@
// @key: @#@"speakerSource"@#@ @source: @#@"Speaker source"@#@
// @key: @#@"speakerVolume"@#@ @source: @#@"Speaker volume"@#@
// @key: @#@"ringtoneSource"@#@ @source: @#@"Ringtone and notification source"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone and notification volume"@#@
// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"noDevices"@#@ @source: @#@"No devices"@#@
// @key: @#@"off"@#@ @source: @#@"Off"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"stopRecordDescription"@#@ @source: @#@"Say something to check your mic level ({countDown} sec)"@#@
// @key: @#@"stopPlaybackDescription"@#@ @source: @#@"Playing your recording..."@#@
// @key: @#@"startRecordButton"@#@ @source: @#@"Test microphone"@#@
// @key: @#@"stopRecordButton"@#@ @source: @#@"Stop recording"@#@
// @key: @#@"stopPlaybackButton"@#@ @source: @#@"Stop test"@#@
// @key: @#@"startTestButton"@#@ @source: @#@"Test speaker"@#@
// @key: @#@"stopTestDescription"@#@ @source: @#@"Playing sample sound..."@#@
